export enum EntityTypeEnum {
    TechnologyType = 1,
    CaseType = 2,
    ScienceArticleType = 3,
    PatentType = 4,
    WebPageType = 5,
    OrganizationType = 6,
    ConceptType = 7
}